<template>
  <FormContent type="page" :newOption="newOption" />
</template>

<script>
import FormContent from '@/components/FormContent'

export default {
  name: 'Pages',
  components: {
    FormContent
  },
  computed: {
    newOption() {
      return this.$route.path.includes('new/local-areas')
    }
  }
}
</script>
